import { useMapEvent } from 'react-leaflet';
import { Map as LeafletMap } from 'leaflet';

type Props = {
  setMap: (map: LeafletMap) => void;
};

export const MapEventHandler = ({ setMap }: Props) => {
  const map = useMapEvent('load', () => {
    setMap(map);
  });

  return null;
};
